var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.7143 56.5714V55.3809C88.7143 50.1211 84.45 45.8571 79.1907 45.8571H70.8571C64.9398 45.8571 60.1429 50.6541 60.1429 56.5714C60.1429 62.4888 64.9398 67.2857 70.8571 67.2857H78C83.9171 67.2857 88.7143 72.0829 88.7143 78C88.7143 83.9171 83.9171 88.7143 78 88.7143H70.8571C64.9398 88.7143 60.1429 83.9171 60.1429 78M56.5714 45.8571H20.8571M38.7143 45.8571V92.2857M3 3H103V103H3V3Z",
    stroke: "#1c7e75",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs);
export default __webpack_public_path__ + "static/media/TS.cd48cd104062e626f5bfa29143a30bd5.svg";
export { ForwardRef as ReactComponent };